import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 27,
    s: 35
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) {
          s--;
        } else {
          s = 59;
          if (m > 0) {
            m--;
          } else {
            m = 59;
            if (h > 0) {
              h--;
            } else {
              clearInterval(timer);
              return {
                h: 0,
                m: 0,
                s: 0
              };
            }
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const Block = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="bg-white border border-green-200 rounded-xl px-4 py-3 min-w-[72px] md:min-w-[88px] text-center shadow-sm" data-id="element-13">
      <div className="text-3xl md:text-5xl font-bold text-green-600 font-mono leading-none" data-id="element-14">
        {String(value).padStart(2, '0')}
      </div>
      <div className="text-[10px] md:text-xs text-slate-500 mt-1 uppercase tracking-widest font-sans font-medium" data-id="element-15">
        {label}
      </div>
    </div>;
  return <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-16">
      <Block value={timeLeft.h} label="hs" data-id="element-17" />
      <span className="text-2xl md:text-4xl text-green-300 font-bold pb-4" data-id="element-18">
        :
      </span>
      <Block value={timeLeft.m} label="min" data-id="element-19" />
      <span className="text-2xl md:text-4xl text-green-300 font-bold pb-4" data-id="element-20">
        :
      </span>
      <Block value={timeLeft.s} label="seg" data-id="element-21" />
    </div>;
}